module.exports = __webpack_public_path__ + "img/40px.031ccc6c.png";